import EnquiryLandingContent from './Content';
import useEnquiryLanding from './useEnquiryLanding';

const EnquiryLanding: React.FunctionComponent = function () {
  const props = useEnquiryLanding();
  return <EnquiryLandingContent {...props} />;
};

export default EnquiryLanding;
